<template>
  <div class="flex flex-col gap-0">
    <vs-textarea
      :value="value"
      @input="$emit('input', $event)"
      v-bind="$attrs"
      v-on="$listeners"
      :disabled="disabled"
      :placeholder="placeholder"
      :class="{ 'has-error': danger, 'w-full flex flex-row': true }"
    />
    <span
      v-if="danger && dangerText"
      class="text-danger"
      style="font-size: .65rem;"
    >{{ dangerText }}</span>
  </div>
</template>
  
<script>
export default {
  name: 'ValidatedTextarea',
  props: {
    value: {
      type: String,
      default: 'teee'
    },
    danger: {
      type: Boolean,
      default: () => false
    },
    dangerText: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    }
  }
};
</script>
  
  <style scoped>
  .has-error {
    outline: 2px solid #EE443F !important;
  }
  </style>